import LinkifyText from "./LinkifyText";

export default LinkifyText;
